import ExpSDK from '@component/experiment';

const Backbone = require('backbone');
const $ = require('jquery');

module.exports = Backbone.Router.extend({
  routes: {
    'myaccount/:page': 'accountHome',

    'account/profile': 'showProfileManagement',

    'my-credit/gateway/cards/:index': 'showCreditGateway',
    'my-credit/gateway/guest': 'showCreditGateway',
    'my-credit/gateway/error': 'showCreditGateway',
    'my-credit/gateway/credit-down': 'showCreditGateway',
    'my-credit/gateway/': 'showCreditGateway',
    'my-credit/gateway': 'showCreditGateway',

    'my-credit/gateway/make-payment/authorize/:index': 'showOneTimePayment',
    'my-credit/gateway/make-payment/:index': 'showOneTimePayment',

    'my-credit/gateway/walletload/': 'showCreditGateway',
    'my-credit/gateway/walletload': 'showCreditGateway',

    'my-credit/amex-offers/': 'showAmexOffers',
    'my-credit/amex-offers': 'showAmexOffers',

    'account/signin-loyalty': 'showSignIn',
    'account/signin': 'showSignIn',
    'registry/wedding/regsignin': 'showSignIn',
    'registry/wedding/registrysignin': 'showSignIn',
    'registry/wedding/registrycaptureemail': 'showSignIn',
    'wgl/registry/registrant/signin': 'showSignIn',
    'wgl/registry/signin': 'showSignIn',
    'account/createaccount': 'showCreateAccountPage',

    'account/report-abuse': 'showActivateAccountReportAbusePage',
    'account/activateaccount': 'showActivateAccountReportAbusePage',
  },

  async accountHome() {
    if (process.env.ENTRY_POINT === 'bcom') {
      // can't use await syntax here as webpack needs to know not to build it for mcom
      import(/* webpackChunkName: "account-home-bcom" */ '@feature/my-account-home-bcom').then(() => {
        this.trigger('app:init-feature', {
          feature: 'my-account-home',
          el: 'my-account-home-bcom',
        });
        this.trigger('load:delayed:scripts');
        this.setMetaDescription('my-account-home');
      });
    } else {
      Promise.all([
        import(/* webpackChunkName: "account-home" */ '@feature/my-account-home'),
        import(/* webpackChunkName: "pros-factory" */ '@feature/pros-factory'),
      ]).then(() => {
        this.trigger('app:init-feature', {
          feature: 'my-account-home',
        });
        this.trigger('load:delayed:scripts');
      });
    }
  },

  async showCreditGateway(givenIndex) {
    let index = givenIndex;
    await import(/* webpackChunkName: "credit-gateway" */ '@feature/credit-gateway');
    // Currently if any query params in URL, it is assigning to index variable as a result gateway page is not loading properly
    // To avoid it, we are checking if index has other than integer value and making it as undefined. In credit-gateway Main.js,
    // we are initializing index as 0 if it is undefined.
    if (index === null || isNaN(index)) { // eslint-disable-line no-restricted-globals
      index = undefined;
    }

    this.trigger('app:init-feature', {
      feature: 'credit-gateway',
      index,
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('credit-gateway');
  },

  async showAmexOffers(givenIndex) {
    let index = givenIndex;
    await import(/* webpackChunkName: "credit-gateway" */ '@feature/credit-gateway');
    // Currently if any query params in URL, it is assigning to index variable as a result gateway page is not loading properly
    // To avoid it, we are checking if index has other than integer value and making it as undefined. In credit-gateway Main.js,
    // we are initializing index as 0 if it is undefined.
    if (index === null || isNaN(index)) { // eslint-disable-line no-restricted-globals
      index = undefined;
    }
    this.trigger('app:init-feature', {
      feature: 'amex-offers',
      index,
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('amex-offers');
  },

  showOneTimePayment(index) {
    this.trigger('app:init-feature', {
      feature: 'one-time-payment-page',
      index,
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('one-time-payment-page');
  },

  async showSignIn(params) {
    await import(/* webpackChunkName: "unified-login", webpackPrefetch: true */ '@feature/unified-login');
    this.trigger('app:init-feature', {
      feature: 'unified-login',
      params: (params) ? params.split('&') : [],
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('unified-login');
  },

  async showCreateAccountPage(params) {
    await import(/* webpackChunkName: "create-account" */ '@feature/create-account');
    ExpSDK.fireAdobeTags();
    let loyaltyExpEnabled;
    ExpSDK.isRecipeSelected('2058-21').then((response) => {
      if (response) {
        loyaltyExpEnabled = true;
      }
    });
    this.trigger('app:init-feature', {
      feature: 'create-account',
      params: (params) ? params.split('&') : [],
      loyaltyExp: loyaltyExpEnabled,
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('create-account');
  },

  async showProfileManagement(params) {
    await import(/* webpackChunkName: "profile-management" */ '@feature/profile-management');
    ExpSDK.fireAdobeTags();
    this.trigger('app:init-feature', {
      feature: 'profile-management',
      params: (params) ? params.split('&') : [],
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('profile-management');
  },

  async showActivateAccountReportAbusePage(params) {
    await import(/* webpackChunkName: "activate-account-report-abuse" */ '@feature/activate-account-report-abuse');
    this.trigger('app:init-feature', {
      feature: 'activate-account-report-abuse',
      params: (params) ? params.split('&') : [],
    });
    this.trigger('load:delayed:scripts');
    this.setMetaDescription('activate-account-report-abuse');
  },

  setMetaDescription(page) {
    // set meta only for Bloomingdale's
    if (process.env.ENTRY_POINT === 'bcom') {
      const descriptions = {
        'my-account-home': 'Click to manage your Bloomingdale\'s account securely to make payments, check loyallist points, view your order history and more!',
        'credit-gateway': 'Everything about your Bloomingdale\'s credit card – right at your fingertips. Open a credit card and take 15% off your purchase, or activate your card and start earning points.',
        'amex-offers': 'Everything about your Bloomingdale\'s credit card — right at your fingertips. Open a credit card and take 15% off your purchase, or activate your card and start earning points.',
        'unified-login': 'Sign in to check out faster, earn points while you shop, manage your account preferences and more!',
        'create-account': 'New to Bloomingdale\'s? Create an account to check out faster, earn points, easily track your orders, pay bills online and more!',
        'profile-management': 'Keep your email, phone, address and other personal details up to date using your profile tools.',
        'activate-account-report-abuse': 'Need to report abuse on your credit card? Click to find out how Bloomingdale’s can help you maintain your credentials.',
      };

      const description = descriptions[page];
      if (description && $('meta[name="description"]').length) {
        $('meta[name="description"]').attr('content', description);
      }
    }
  },
});
